import React from 'react';
import { Link } from 'react-router-dom';

const LegacyCtaSection = () => (
  <section className="px-6 py-20" id="cta">
    <div className="max-w-5xl mx-auto">
      <div className="relative rounded-3xl overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-emerald-500/20 via-cyan-500/20 to-amber-400/20" />
        <div className="relative border border-white/10 bg-[#131820]/95 backdrop-blur-xl p-12 md:p-16 text-center">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-4xl md:text-5xl font-bold text-[#f8f5ed] mb-6 leading-tight">
              Your next meeting could be the last one where you argue about payments.
            </h2>
            <p className="text-xl text-[#d8d2c5] mb-8 leading-relaxed">
              Stop managing your chama with WhatsApp and Excel. GroupHela keeps everyone on the same
              page—literally.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
              <Link
                to="/register"
                className="inline-flex items-center gap-2 rounded-full bg-emerald-400 text-[#0f1115] px-8 py-4 text-lg font-bold shadow-xl shadow-emerald-500/30 hover:shadow-emerald-500/50 hover:bg-emerald-300 transition-all"
              >
                Start free now
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.5}
                    d="M13 7l5 5m0 0l-5 5m5-5H6"
                  />
                </svg>
              </Link>
              <Link
                to="/login"
                className="inline-flex items-center gap-2 text-lg text-[#d8d2c5] hover:text-emerald-300 transition"
              >
                Already have an account?
              </Link>
            </div>

            <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-[#d8d2c5]/70">
              <div className="flex items-center gap-2">
                <svg className="w-4 h-4 text-emerald-400" fill="currentColor" viewBox="0 0 20 20">
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clipRule="evenodd"
                  />
                </svg>
                <span>Free forever plan</span>
              </div>
              <div className="flex items-center gap-2">
                <svg className="w-4 h-4 text-emerald-400" fill="currentColor" viewBox="0 0 20 20">
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clipRule="evenodd"
                  />
                </svg>
                <span>5-minute setup</span>
              </div>
              <div className="flex items-center gap-2">
                <svg className="w-4 h-4 text-emerald-400" fill="currentColor" viewBox="0 0 20 20">
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clipRule="evenodd"
                  />
                </svg>
                <span>No credit card needed</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default LegacyCtaSection;
